//@ts-nocheck
import React, { useState, useMemo } from "react";
import {
    Card,
    CardContent,
    CardActions,
    Button,
    TextField,
    Typography,
    Stack,
    Box,
    FormControl,
    Autocomplete,
} from "@mui/material";
import { FileSearch } from '../../../assets/icons';
import { IGetFTPBankListResponse, useGetFTPBankList, useDownloadBankFTP } from "../../../hooks";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { CircularProgress } from '@mui/material';

export const FTPFilesComponent: React.FC = () => {
    const [selectedBank, setSelectedBank] = useState<IGetFTPBankListResponse | null>(null);
    const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);
    const setSnackbar = useSetSnackBar();

    const { data: rawBankList } = useGetFTPBankList();
    const { mutate: downloadBankFTP, isLoading: isDownloadFileLoading } = useDownloadBankFTP();

    const bankOptions = useMemo(() => {
        if (!rawBankList) return [];
        return rawBankList?.map(bank => ({
            label: `${bank.bankName || bank.bankCode} (${bank.bankCode})`,
            value: bank.bankCode,
            ...bank
        }));
    }, [rawBankList]);

    const handleDownload = () => {
        if (!selectedBank || !selectedDate) return;

        const payload = {
            bankCode: selectedBank.bankCode,
            date: selectedDate.format('YYYY-MM-DD'),
            bankName: selectedBank.bankName || selectedBank.bankCode
        };

        downloadBankFTP(payload, {
            onSuccess: ({ blob, fileName }) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            },
            onError: (error: any) => {
                setSnackbar({
                    severity: "error",
                    description: error?.message || "Dosya indirilemedi.",
                    isOpen: true,
                });
            },
        });
    };

    const handleDateChange = (newValue: dayjs.Dayjs | null) => {
        setSelectedDate(newValue);
    };

    return (
        <Stack
            flex={1}
            justifyContent="center"
            alignItems="center"
            px={2}
        >
            <Card
                sx={{
                    width: "100%",
                    maxWidth: 750,
                    boxShadow: 'none'
                }}
            >
                <CardContent>
                    <Box display="flex" justifyContent="center">
                        <FileSearch width={350} />
                    </Box>

                    <Typography
                        variant="h4"
                        align="center"
                        gutterBottom
                        sx={{ fontWeight: 600 }}
                    >
                        FTP Dosyası İndir
                    </Typography>

                    <Typography
                        variant="body2"
                        align="center"
                        color="text.secondary"
                        sx={{ mb: 3 }}
                    >
                        Banka ve tarih seçerek FTP dosyasını indirebilirsiniz.
                    </Typography>

                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                        <Stack spacing={3} direction={'row'} justifyContent={'space-between'}>
                            <FormControl sx={{ flex: 1 }}>
                                {bankOptions?.length > 0 && (
                                    <Autocomplete
                                        id="bankCode"
                                        placeholder="Banka seçiniz"
                                        options={bankOptions}
                                        getOptionLabel={(option) => option.label}
                                        value={selectedBank}
                                        onChange={(_, newValue) => {
                                            setSelectedBank(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Banka seçiniz" />
                                        )}
                                    />
                                )}
                            </FormControl>

                            <FormControl sx={{ flex: 1 }}>
                                <DatePicker
                                    label="Tarih"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    format="DD.MM.YYYY"
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            error: false
                                        }
                                    }}
                                />
                            </FormControl>
                        </Stack>
                    </LocalizationProvider>
                </CardContent>

                <CardActions sx={{ justifyContent: "center", pb: 3, px: 2 }}>
                    <Button
                        variant="contained"
                        size="large"
                        fullWidth
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                        }}
                        onClick={handleDownload}
                        disabled={!selectedBank || !selectedDate || isDownloadFileLoading}
                        startIcon={isDownloadFileLoading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {isDownloadFileLoading ? 'İndiriliyor...' : 'İndir'}
                    </Button>
                </CardActions>
            </Card>
        </Stack>
    );
};
